const mediaWidths = {
  medium: 750,
  large: 990,
  widescreen: 1400,
};

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach(summary => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", "false");

  if (summary.nextElementSibling && summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", event => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open"),
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = event => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", event => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", event => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true,
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach(video => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*",
    );
  });
  document.querySelectorAll(".js-vimeo").forEach(video => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach(video => video.pause());
  document.querySelectorAll("product-model").forEach(model => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach(button =>
      button.addEventListener("click", this.onButtonClick.bind(this)),
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options["hideElement"] || province_domid);

  Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`);

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach(summary =>
      summary.addEventListener("click", this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll("button").forEach(button =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this)),
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector("button"));
      summaryElement.nextElementSibling.removeEventListener("transitionend", addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener("transitionend", addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.querySelectorAll("details").forEach(details => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    detailsElement.querySelector("summary").setAttribute("aria-expanded", false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = time => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary"),
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
        this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom")
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
    );

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define("header-drawer", HeaderDrawer);

const ModalDialog = class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this));
    this.addEventListener("keyup", event => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", event => {
        if (event.pointerType === "mouse" && !event.target.closest("deferred-media, product-model"))
          this.hide();
      });
    } else {
      this.addEventListener("click", event => {
        if (event.target.nodeName === "MODAL-DIALOG") this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
};
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(true));

      this.setAttribute("loaded", true);
      this.appendChild(content.querySelector("video, model-viewer, iframe")).focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector("ul");
    this.sliderItems = this.querySelectorAll("li");
    this.pageCount = this.querySelector(".slider-counter--current");
    this.pageTotal = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(
      element => element.clientWidth > 0,
    );
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.pageTotal.innerHTML;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + this.sliderLastItem.clientWidth
        : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.isCard = this.getAttribute("data-is-card") === "true";
    this.addEventListener("change", this.onVariantChange);
    this.updateOptions();


    this.filterOptions()
  }

  onVariantChange() {
    if (this.isCard) {
      this.updateOptions();
      this.updateVariantName();
      this.updateMasterId();
      this.toggleCardButton(true, "");

      if (!this.currentVariant) {
        this.toggleCardButton(true, window.variantStrings.unavailable);
      } else if (!this.currentVariant.available) {
        this.toggleCardButton(true, window.variantStrings.soldOut);
      } else {
        this.toggleCardButton(false);
      }

      return;
    }

    this.updateOptions();
    this.updateVariantName();
    this.updateMasterId();
    this.filterOptions()
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      // this.renderProductOptionValues();
      this.updateShareUrl();
    }
  }

  filterOptions () {
    const optionsEls = [...this.querySelectorAll('[data-option]')]
    const isStyle = optionsEls.some((el) => el.getAttribute('data-option') === "Style")
    let indexStyle, currentStyle
    if (isStyle) {
      indexStyle = optionsEls.findIndex((el) => el.getAttribute('data-option') === "Style")
      currentStyle = this.options[indexStyle]
    }
    if (!currentStyle) return
    const labelEls = this.querySelectorAll('.product-form__input:not([data-option="Style"]) label[data-option]')
    labelEls.forEach((el) => {
      el.classList.add('hidden')
    })
    this.variantData.forEach(variant => {
      if (variant.options[indexStyle] === currentStyle) {
        variant.options.forEach((option, index) => {
          if (index !== indexStyle) {
            const el = this.querySelector(`label[data-option="${option}"]`)
            if (el) el.classList.remove('hidden')
          }
        })
      }
    })

    const containers = this.querySelectorAll('.product-form__input:not([data-option="Style"])')
    if (!this.currentVariant && containers) {
      containers.forEach((container) => {
        const labels = container.querySelectorAll('label[data-option]:not(.hidden)')
        if (labels.length > 0) {
          const value = labels[0].getAttribute('data-option')
          container.querySelector(`input[value="${value}"]`).click()
        }
      })
    }
  }
  updateOptions() {
    this.options = Array.from(this.querySelectorAll("select"), select => select.value);
  }

  updateVariantName() {
    const options = this.querySelectorAll(".product-form__input");

    options.forEach(option => {
      const name = option.querySelector('input[type="radio"]:checked').value;
      option.querySelector(".selected-option").innerHTML = name;
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find(variant => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });

    if (this.currentVariant && this.isCard) {
      this.closest("form").querySelector('[name="id"]').value = this.currentVariant.id;
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`,
    );

    if (!newMedia) return;
    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`,
    );
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`,
    );
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader = this.stickyHeader || document.querySelector("sticky-header");
    if (this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
    }
    window.setTimeout(() => {
      parent.scrollLeft = 0;
      parent.querySelector("li.product__media-item").scrollIntoView({ behavior: "smooth" });
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`,
    );
    productForms.forEach(productForm => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`,
    )
      .then(response => response.text())
      .then(responseText => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const productInfoEl = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && productInfoEl) productInfoEl.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut,
          true,
          true,
        );

        // Render renderProductOptionValues
        const renderProductOptionValues = html.querySelector(`[data-product-inner]`);
        const productOptionEl = document.querySelector(`[data-product-inner]`);

        if (renderProductOptionValues && productOptionEl) productOptionEl.innerHTML = renderProductOptionValues.innerHTML;
        productOptionEl.classList.remove('disable');

        // Render Product Image
        const productImage = html.querySelector('[data-product-images]')
        const productImageEl = document.querySelector(`[data-product-images]`)
        if (productImage && productImageEl) productImageEl.innerHTML = productImage.innerHTML;
        this.filterOptions()
      });
  }

  // renderProductOptionValues() {
  //
  //   const destination = document.querySelector(`[data-product-inner]`);
  //   destination.classList.add('disable');
  //
  //   fetch(
  //     `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`,
  //   )
  //     .then(response => response.text())
  //     .then(responseText => {
  //       const html = new DOMParser().parseFromString(responseText, "text/html");
  //       const source = html.querySelector(`[data-product-inner]`);
  //
  //       if (source && destination) destination.innerHTML = source.innerHTML;
  //       destination.classList.remove('disable');
  //
  //     });
  // }

  renderProductVariantImages () {

  }

  toggleCardButton(disable = true, text) {
    const productForm = this.closest("form");
    if (!productForm) return;
    const addButton = productForm.querySelector('[type="submit"]');
    const addButtonText = productForm.querySelector('[type="submit"] > span');
    const errorMessage = productForm.querySelector(".product-form__error-message-wrapper");
    const addToCartText = addButtonText.getAttribute('data-add-to-cart-text');

    errorMessage && errorMessage.setAttribute("hidden", "hidden");

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) {
        addButtonText.innerHTML = text;
      } else {
        addButtonText.innerHTML = addToCartText;
      }
    } else {
      addButton.removeAttribute("disabled");
      if (addToCartText) {
        addButtonText.innerHTML = addToCartText;
      } else {
        addButtonText.innerHTML = window.variantStrings.addToCart;
      }
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true, stock) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      this.toggleNotifyMessage(stock);
      if (text) {
        addButtonText.textContent = text;
      }
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
    this.toggleNotifyMessage();
  }

  toggleNotifyMessage(display) {
    const notify = document.querySelector("out-of-stock-notification");

    if (display) {
      notify.classList.remove("hidden");
      return;
    }

    notify.classList.add("hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map(fieldset => {
      return Array.from(fieldset.querySelectorAll("input")).find(radio => radio.checked).value;
    });
    /*
    
      when updateMasterId(), will only return if a variant
      is available from the selected options. There has been some changes on
      liquid that will only show available option2's depending
      on option1 selection, therefore when some selections are made there is a possiblility
      the updateURL won't run because the variant doesn't exist.
    
      Below assigns a found variant option 2 to this.options[1];
    */
    this.updateMasterId() // creates this.currentVariant
    if (this.currentVariant != null) return null;

    const variantWithOption1 = this.variantData.find(variant => {
      return variant.option1 == this.options[0] && variant
    })

    this.options[1] = variantWithOption1.option2;
  }
}

customElements.define("variant-radios", VariantRadios);

class AnnouncementDropdown extends HTMLElement {
  constructor() {
    super();
    this.dropdown = this.querySelector(".abn-dropdown");
    this.selectedButton = this.querySelector(".abn-special-selected");
    this.init();
  }

  init() {
    this.selectedButton.addEventListener("click", () => {
      if (parseInt(this.selectedButton.dataset.status) === 0) {
        this.showDropdown();
        return;
      }

      this.hideDropdown();
    });

    this.dropdown.addEventListener("mouseleave", () => {
      this.hideDropdown();
    });
  }

  showDropdown() {
    this.dropdown.style.display = "initial";
    setTimeout(() => {
      this.dropdown.style.opacity = 1;
    }, 100);

    this.selectedButton.dataset.status = 1;
  }

  hideDropdown() {
    this.dropdown.style.opacity = 0;
    setTimeout(() => {
      this.dropdown.style.display = "none";
    }, 100);

    this.selectedButton.dataset.status = 0;
  }
}

customElements.define("announcement-dropdown", AnnouncementDropdown);

class SetMenuHeight {
  constructor() {
    this.init();
  }

  init() {
    const headerHeight = document.querySelector('.header-wrapper').offsetHeight;
    const announcementBar = document.getElementById('shopify-section-announcement-bar');
    const announcementHeight = announcementBar ? announcementBar.offsetHeight : 0;
    const menuDrawer = document.getElementById('menu-drawer');
    const currentScroll = document.documentElement.scrollTop

    if (menuDrawer) {
      if(currentScroll < announcementHeight) {
        menuDrawer.style.height = `calc(100vh - ${headerHeight + announcementHeight}px)`;
      }else {
        menuDrawer.style.height = `calc(100vh - ${headerHeight}px)`;
      }
    }
  }

}

new SetMenuHeight();

/*============================================================================
Local Storage Expiry Time
==============================================================================*/
function setWithExpiry(key, value, ttl = 86400000) {
  const now = new Date()
  // 24 hours in miliseconds is 86400000
  // `item` is an object which contains the original value
  // as well as the time when it's supposed to expire
  const item = {
    value: value,
    expiry: now.getTime() + ttl,
  }
  localStorage.setItem(key, JSON.stringify(item))
}

function getWithExpiry(key) {
  const itemStr = localStorage.getItem(key)
  // if the item doesn't exist, return null
  if (!itemStr) {
    return null
  }
  const item = JSON.parse(itemStr)
  const now = new Date()
  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key)
    return null
  }
  return item.value
}

/*============================================================================
Cart Add Fetch
==============================================================================*/
const cartAdd = async (formData, callback, url = "/cart/add.js") => {
  if (!formData) return;

  await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then(response => {
      return response.json();
    })
    .then(response => {
      callback && callback(response);
    })
    .catch(e => {
      location.reload();
    });
};

function throttle(func, wait = 100) {
  let timer = null;
  return function (...args) {
    if (timer === null) {
      timer = setTimeout(() => {
        func.apply(this, args);
        timer = null;
      }, wait);
    }
  };
}

class ImageWrapper extends HTMLElement {
  constructor() {
    super();

    this.image = this.querySelector("img");

    const imgWidth = parseInt(this.image.getAttribute("width"));
    const imgHeight = parseInt(this.image.getAttribute("height"));
    const imgRatio = (imgHeight / imgWidth) * 100;

    this.style.paddingTop = `${imgRatio}%`;
  }
}

customElements.define("image-wrapper", ImageWrapper);


class SlideOutCart {
  constructor() {
    this.slideOutCart = document.querySelector(".snippet-slide-out-cart");
    this.slideCartDrawer = document.querySelector(".cart-drawer");
    this.timer = null;
    this.init();
    this.cart;
  }

  async init() {
    if (this.slideCartDrawer) {
      await this.getCart();
    }

    if (!this.slideOutCart) {
      return;
    }

    document.querySelector(".cart-drawer-header .icon-close").addEventListener("click", () => {
      this.closeCart();
    });

    this.slideOutCart.addEventListener("click", e => {
      if (e.target.id === "snippet-slide-out-cart") {
        this.closeCart();
      }
    });
  }

  async getCart() {
    await fetch("/cart.js")
      .then(response => response.json())
      .then(async data => {
        this.onFetchComplete(data);
      })
      .catch(e => console.error(e));
  }

  async onFetchComplete(data) {
    const gwp = new GiftWithPurchase(data);
    await gwp.init();
    const gwpResponse = await gwp.response();

    new CartUpsell(gwpResponse);

    this.updateBubble(gwpResponse);

    this.renderItems(gwpResponse.items);
    this.renderTotal(gwpResponse);
    this.renderSaved(gwpResponse)
    this.renderEmptyCart(gwpResponse.item_count >= 1);

    if (this.slideCartDrawer) {
      this.slideCartDrawer.classList.remove("disabled");
    }

    this.cart = gwpResponse;
  }

  updateBubble(data) {
    const count = data.item_count;
    const bubble = document.querySelector(".cart-count-bubble");
    const spans = bubble.querySelectorAll("span");

    if (count === 0) {
      bubble.classList.add("hidden");
    } else {
      bubble.classList.remove("hidden");
    }

    spans.forEach(span => (span.textContent = count));
  }

  renderEmptyCart(hide = true) {
    if (!this.slideCartDrawer) return;

    const cartEmpty = document.querySelector(".cart-drawer-empty");

    if (hide) {
      return (cartEmpty.style.display = "none");
    }
    return (cartEmpty.style.display = "initial");
  }

  renderItems(items) {
    if (!this.slideCartDrawer) return;
    const variantNames = variant_options => {
      return variant_options
        .map(variant_option => {
          if (variant_option.value === "Default Title") {
            return;
          }
          return "<p>" + variant_option.name + ": " + variant_option.value + "</p>";
        })
        .join("");
    };

    const itemList = items
      .map((item, i) => {
        return `
      <li class="cart-drawer-item th_pb_cart_line" data-idth="${item.id}" data-indexth="${i + 1
          }" id="cart-drawer-${item.id}" data-item-id="${item.id}" data-line="${i + 1}">
        <div class="cdi-close th_pb_remove_cart_item">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="icon icon-close"><path d="M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z" fill="currentColor"></path></svg>
        </div>

        <div class="cdi-img">
          <span class="cdi-img-wrapper">
            <a href="${item.url}"> <img src="${item.image}" /></a>
          </span>
        </div>

        <div class="cdi-details">
          <h3><a href="${item.url}">${item.product_title}</a></h3>
          <div class="cdi-details-options">
            ${variantNames(item.options_with_values)}
          </div>
          <span class="th_bundle_discount_text"></span>
          <div class="quantity__price">
             ${!item.properties?.gift_with_purchase && !item.properties?.th_bundle_type
            ? this.htmlQuantityInput(item.quantity)
            : `Quantity: ${item.quantity}`
        }
            <div class="cdi-price th_item_line_price">$${(item.final_line_price / 100).toFixed(2)}${item.original_line_price > item.final_line_price
            ? ` <s>$${(item.original_line_price / 100).toFixed(2)}</s>`
            : ""
        }</div>
          </div>
        </div>
      </li>`;
      })
      .join("");

    const parser = new DOMParser();
    const destination = document.querySelector(".cart-drawer-items ul");
    const source = parser.parseFromString(itemList, "text/html").body.innerHTML;

    destination.innerHTML = source;
    if (items.length > 0) {
      this.renderUpsell(items[0].product_id)
    }
    this.cartItemEvents();
  }

  renderUpsell (id) {
    const upSaleContainer = document.querySelector('.cart-upsell')
    if(!upSaleContainer) return
    let upSellEl = document.querySelector('#upsell-list')
    upSaleContainer.style.display = 'block'
    if(upSellEl && upSellEl.innerHTML === ''){
      fetch(window.Shopify.routes.root + `recommendations/products?product_id=${id}&limit=4&section_id=upsell-recommendations`)
          .then(response => response.text())
          .then((data) => {
            upSellEl.innerHTML = data
            const swiperOptions = {
              direction: "horizontal",
              loop: false,
              autoHeight: true,
              pagination: {
                el: ".swiper-pagination",
                type: "bullets",
                clickable: true,
              }
            }
            const swiper = new Swiper(".upsell-recommendations", swiperOptions);
            swiper
          })
    }
  }

  fetchCartSection() {
    const destination = document.querySelector(".cart-drawer-items ul");

    fetch("/cart?section_id=main-cart-items")
      .then(response => response.text())
      .then(responseText => {
        const html = responseText;
        destination.innerHTML = html;
        // this.cartItemEvents();
      });
  }

  cartItemEvents() {
    const cartItems = document.querySelectorAll(".cart-drawer-item");

    cartItems.forEach(currentItem => {
      currentItem.addEventListener("change", () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.changeCart(
            currentItem.dataset.itemId,
            currentItem.querySelector(".quantity__input").value,
          );
        }, 500);
      });

      currentItem.querySelector(".cdi-close .icon-close").addEventListener("click", () => {
        this.changeCart(currentItem.dataset.itemId, 0);
      });
    });
  }

  renderTotal(data) {
    if (!this.slideCartDrawer) return;
    const totalElement = document.querySelector("[data-total]");
    const price = (data.total_price / 100).toFixed(2)
    totalElement.innerHTML = "$" + price;
    totalElement.dataset.price = price;
  }

  renderSaved(data) {
    if (!this.slideCartDrawer) return;
    const saveContainer = document.querySelector(".cart-drawer-save")
    const saveEl = saveContainer.querySelector("[data-saved]")
    if (data.total_discount && data.total_discount > 0) {
      saveContainer.style.display = 'flex'
      const price = (data.total_discount / 100).toFixed(2)
      saveEl.innerHTML = "$" + price;
      saveEl.dataset.price = price;
    } else {
      saveContainer.style.display = 'none'
    }
  }

  async changeCart(itemId, qty) {
    this.slideCartDrawer.classList.add("disabled");

    await fetch(`${routes.cart_change_url}`, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id: itemId, quantity: qty }),
    })
      .then(res => res.json())
      .then(async res => {
        if (!this.slideOutCart && this.slideCartDrawer && hasBundle) {
          location.reload();
          return;
        }
        this.onFetchComplete(res);
      });
  }

  htmlQuantityInput(qty = 1) {
    return `<quantity-input class="quantity">
    <button class="quantity__button no-js-hidden" name="minus" type="button">
      <span class="visually-hidden">Decrease quantity for silent waterfall</span>
      <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" fill="none" viewBox="0 0 10 2">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor">
  </path></svg>
  
    </button>
    <input class="quantity__input" type="number" name="quantity" id="Quantity-" min="1" value="${qty}" form="">
    <button class="quantity__button no-js-hidden" name="plus" type="button">
      <span class="visually-hidden">Increase quantity for silent waterfall</span>
      <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor">
  </path></svg>
  
    </button>
    </quantity-input>`;
  }

  async openCart(notification = false) {
    const slideOutCart = document.querySelector(".snippet-slide-out-cart");
    const slideCartDrawer = document.querySelector(".cart-drawer");
    const body = document.querySelector('body')
    body.classList.add('slideout-open')
    if (!slideOutCart && hasBundle) {
      if (slideCartDrawer) {
        location.reload();
        return;
      }
      if (notification) {
        document.querySelector("#cart-notification").classList.add("animate", "active");
        await this.getCart();
        return;
      }
      window.location.href = "/cart";
      return;
    }

    if (!slideOutCart) return;

    document.body.style.overflow = "hidden";
    slideOutCart.style.display = "initial";

    setTimeout(() => {
      slideOutCart.style.opacity = 1;
    }, 200);

    setTimeout(() => {
      slideCartDrawer.style.right = 0;
    }, 400);

    setTimeout(() => {
      new CartUpsell(this.cart);
    }, 1000);
  }

  closeCart() {
    const body = document.querySelector('body')
    body.classList.remove('slideout-open')
    this.slideCartDrawer.style.right = "-100%";

    setTimeout(() => {
      this.slideOutCart.style.opacity = 0;
    }, 200);

    setTimeout(() => {
      document.body.style.overflow = "initial";
      this.slideOutCart.style.display = "none";
    }, 400);
  }
}

class HeaderMain extends HTMLElement {
  constructor() {
    super();

    this.wrapper = this.querySelector(".header-wrapper");
    this.logo = this.querySelector(".header__heading-logo");
    this.menuTrigger = this.querySelector("summary");
    this.logoOriginalSrcSet = this.logo?.srcset;
    this.liParents = this.querySelectorAll(".li-parent");
    this.megaMenus = this.querySelectorAll(".snippet-mega-nav");
    this.headerSolid = document.querySelector("[data-header-solid]");
    this.ctas = this.querySelectorAll(".mn-cta-card");
    this.subMenusMob = this.querySelectorAll(".menu-drawer__submenu");
    this.stickyHeader = this.querySelector('sticky-header')

    this.init();
  }

  init() {
    const sliderDrawer = new SlideOutCart();

    if (this.headerSolid) {
      this.designSolid();
    }

    if (!this.stickyHeader.classList.contains('color-background-1')) {
      window.addEventListener("scroll", () => {
        throttle(this.scrollChangeDesign(), 200);
      });
    }


    this.menuTrigger.addEventListener("click", () => {
      this.mobMenuChangeDesign();
    });

    if (window.innerWidth > mediaWidths.medium) {
      this.doMegaMenu();
    }

    this.querySelector("#header-cart-icon").addEventListener("click", e => {
      e.preventDefault();

      sliderDrawer.openCart();
    });

    this.renderCtaMobile();
  }

  mobMenuChangeDesign() {
    const dataOpen = this.menuTrigger.dataset.open;

    if (!dataOpen || parseInt(dataOpen) === 0) {
      this.menuTrigger.setAttribute("data-open", 1);
      this.designSolid();
    }

    if (dataOpen && parseInt(dataOpen) === 1 && this.bodyScrollTop() <= 399) {
      this.menuTrigger.dataset.open = 0;
      if (!this.headerSolid) {
        this.designTransparent();
      }
    }
  }

  scrollChangeDesign() {
    const headerHeight = this.querySelector(".header").offsetHeight;
    const body = document.body;
    const cartNotification = document.querySelector("#cart-notification");

    if (!this.headerSolid) {
      cartNotification.style.transform = `translateY(${headerHeight}px)`;
    }

    if (this.bodyScrollTop() >= 400) {
      this.toggleDesignClasses("header-fixed");
      this.designSolid();
      if (this.headerSolid) {
        body.style.marginTop = `${headerHeight}px`;
        cartNotification.style.transform = `translateY(${headerHeight}px)`;
      }
    }

    if (this.bodyScrollTop() <= 399) {
      this.toggleDesignClasses("header-fixed", false);
      if (!this.headerSolid) {
        this.designTransparent();
      } else {
        body.style.marginTop = ``;
        cartNotification.style.transform = ``;
      }
    }
  }

  designSolid(float = true) {
    if (float) {
      this.toggleDesignClasses("header-transparent", false);
    }
    this.toggleDesignClasses("color-background-1");
    this.toggleDesignClasses("color-inverse", false);
    this.logo && this.logoChange();
  }

  designTransparent() {
    this.toggleDesignClasses("header-transparent");
    this.toggleDesignClasses("color-background-1", false);
    this.toggleDesignClasses("color-inverse");
    this.logo && this.logoChange(false);
  }

  toggleDesignClasses($className, $add = true) {
    $add ? this.wrapper.classList.add($className) : this.wrapper.classList.remove($className);
  }

  logoChange($dark = true) {
    if (this.logo.dataset.dark == null) return;

    if ($dark) {
      this.logo.srcset = this.logo.dataset.dark;
      return;
    }
    this.logo.srcset = this.logoOriginalSrcSet;
  }

  bodyScrollTop() {
    return document.documentElement.scrollTop || document.body.scrollTop;
  }

  doMegaMenu() {
    if (this.liParents == null) return;

    [...this.liParents].forEach(liParent => {
      const liMegaMenuStatus = liParent.dataset.megamenu;
      const liMegaNav = liParent.querySelector(".snippet-mega-nav");
      const liText = liParent.querySelector(".li-parent-text");

      liText.addEventListener("mouseover", () => {
        if (liMegaMenuStatus == "0" && liParent.dataset.hasMegamenu != null) {
          this.hideAllMegaMenus();
          this.showMegaMenu(liParent);
          this.designSolid(false);
        }

        if (liParent.dataset.hasMegamenu == null) {
          this.hideAllMegaMenus();
          if (!this.headerSolid && this.bodyScrollTop() < 400) {
            this.designTransparent();
          }
        }
      });

      if (liMegaNav != null) {
        liMegaNav.addEventListener("mouseleave", () => {
          this.hideMegaMenu(liParent);
          if (!this.headerSolid) {
            this.designTransparent();
          }
        });
      }
    });
  }

  showMegaMenu(liParent) {
    const megaMenu = liParent.querySelector(".snippet-mega-nav");

    megaMenu.style.display = "block";
    setTimeout(() => {
      megaMenu.style.opacity = 1;
    }, 200);

    liParent.setAttribute("data-megamenu", 1);
  }

  hideMegaMenu(liParent, timeout = true) {
    const megaMenu = liParent.querySelector(".snippet-mega-nav");

    if (megaMenu == null) return;

    megaMenu.style.opacity = 0;

    if (timeout) {
      setTimeout(() => {
        megaMenu.style.display = "none";
      }, 200);
    }

    if (!timeout) {
      megaMenu.style.display = "none";
    }

    liParent.setAttribute("data-megamenu", 0);
  }

  hideAllMegaMenus() {
    if (this.liParents == null) return;

    [...this.liParents].forEach(liParent => {
      this.hideMegaMenu(liParent, false);
    });
  }

  renderCtaMobile() {
    this.subMenusMob.forEach(subMenuMob => {
      const ctasForThisSubMenu = this.querySelectorAll(
        `[data-cta-parent="${subMenuMob.dataset.title}"]`,
      );
      const ul = document.createElement("ul");
      ul.classList.add("menu-drawer__menu", "list-menu", "menu-drawer__menu-cta");

      const liCtas = [...ctasForThisSubMenu]
        .map(cta => {
          const hasIcon = cta.classList.contains("mn-cta-icon") ? true : false;

          return `
          <li class="${hasIcon ? "has-icon" : "no-icon"} ">
            <a href="${cta.href
            }" class="menu-drawer__menu-item link link--text list-menu__item focus-inset">
            ${hasIcon ? `<img src="${cta.dataset.mobIcon}" />` : ""}
            <span>${cta.dataset.ctaTitle}</span>
            </a>
          </li>
        `;
        })
        .join(" ");

      subMenuMob.querySelector(".menu-drawer__inner-submenu").append(ul);
      ul.innerHTML = liCtas;
    });
  }
}

customElements.define("header-main", HeaderMain);
class GiftWithPurchase {
  constructor(cart, callback) {
    this.cart = cart;
    this.callback = callback;

    this.container = document.querySelector("#cart__free_gift");
    this.options = document.querySelectorAll(".cart__free_gift-variant");
    this.select = document.querySelector("[data-product-select]");
    this.addToCart = this.container?.querySelector("[data-add-to-cart]");

    this.cartPrice = [];
    this.active = false;
    this.collection = this.getJSONData("gwp-collection");
    this.data = this.getJSONData("gwp-data");

    if (this.data) {
      this.threshold = parseInt(this.data.gwp.gwp_threshold) * 100;
      this.variantId = this.data.gwp.gwp_variant_id;
      this.enabled = this.data.gwp.gwp_enable;
      this.automated = this.data.gwp.gwp_automate;
    }

    this.return = this.cart;

    this.reducer = (previousValue, currentValue) => previousValue + currentValue;

    this.init();
  }

  async init() {
    if (!this.container || !this.data) return this.cart;

    this.updateCartTotal();

    this.options.forEach(option => option.addEventListener("click", e => this.selectGift(e)));

    await this.checksGwp();
  }

  selectGift(e) {
    e.preventDefault();

    const target = e.target.closest(".cart__free_gift-variant");
    const id = target.dataset.id;

    this.options.forEach(option => option.classList.remove("selected"));

    target.classList.add("selected");
    this.select.value = id;
    this.enableAddToCart();
  }

  enableAddToCart() {
    const value = this.select.value;

    if (value) {
      this.addToCart.removeAttribute("disabled");
      return;
    }

    this.addToCart.setAttribute("disabled", "disabled");
  }

  async checksGwp() {
    const totalCartPrice = this.cartPrice.reduce(this.reducer, 0);

    if (totalCartPrice < this.threshold || this.active) {
      this.container && this.container.classList.add("hidden");
    }

    if (totalCartPrice >= this.threshold && !this.active) {
      if (!this.automated || !this.enabled) {
        this.container && this.container.classList.remove("hidden");
        return;
      } else {
        await this.autoAdd();
      }
    }

    if (totalCartPrice < this.threshold && this.active) {
      await this.removeGift();
    }

    if (!this.enabled) {
      await this.removeGift();
    }
  }

  async removeGift(cartArg) {
    for (let i = 0; i < this.cart.items.length; i++) {
      const item = this.cart.items[i];
      if (item.properties && item.properties["gift_with_purchase"] === "true") {
        const formData = {
          line: i + 1,
          quantity: 0,
        };

        await cartAdd(
          formData,
          response => {
            this.return = response;
          },
          "/cart/change.js",
        );
      }
    }
  }

  async autoAdd() {
    const formData = {
      items: [
        {
          quantity: 1,
          id: this.variantId,
          properties: {
            gift_with_purchase: "true",
          },
        },
      ],
    };

    await cartAdd(formData, response => {
      this.return = {
        ...this.cart,
        items: [...this.cart.items, ...response.items],
      };
    });
  }

  response() {
    return this.return;
  }

  updateCartTotal(cartArg) {
    this.cartPrice = [];

    if (!this.collection) {
      this.cart.items.forEach(item => {
        // Validates cart items for GWP
        if (item.properties && item.properties["gift_with_purchase"] === "true") {
          this.active = true;
        }
        // Adds the cart total price excluding GWP
        if (!item.properties || item.properties["gift_with_purchase"] !== "true") {
          const item_price = item.discounted_price,
            item_quantity = item.quantity;
          this.cartPrice.push(item_price * item_quantity);
        }
      });
      return;
    }

    gwp_collection.forEach(product => {
      cart.items.forEach(item => {
        // Validates cart items for GWP
        if (item.properties && item.properties["gift_with_purchase"] === "true") {
          this.active = true;
        }
        // Adds the cart total price excluding GWP and validates qualified collection
        if (item.handle === product.handle) {
          if (!item.properties || item.properties["gift_with_purchase"] !== "true") {
            const item_price = item.discounted_price,
              item_quantity = item.quantity;
            this.cartPrice.push(item_price * item_quantity);
          }
        }
      });
    });
  }

  getJSONData(eleId) {
    const ele = document.getElementById(eleId);
    const data = ele && JSON.parse(ele.textContent);
    return data;
  }
}

class CartUpsell {
  constructor(cart) {
    this.cart = cart;
    this.cartUpsell = document.querySelector("[data-upsell-threshold]");

    if (this.cartUpsell == null) return;
    if (!this.cart) return;

    this.active = false;
    this.thresholdMet = false;
    this.threshold = parseInt(this.cartUpsell.getAttribute("data-upsell-threshold"));
    this.display = false;
    this.closeBtn = this.cartUpsell.querySelector(".upsell-close");

    this.init();
  }

  init() {
    this.checkRequirement();
    this.checkUpsellDisplay();
    // this.handleUpsellDisplay();

    this.closeBtn.addEventListener("click", () => {
      this.display = false;
      // this.handleUpsellDisplay();
      setWithExpiry("hideUpsell", "true", 86400000); //One day
    });
  }

  handleUpsellDisplay() {
    const height = this.cartUpsell.querySelector(".upsell-inner").offsetHeight;

    if (this.display) {
      this.cartUpsell.style.height = `${height}px`;
    } else {
      this.cartUpsell.style.height = `0`;
    }
  }

  checkUpsellDisplay() {
    if (getWithExpiry("hideUpsell") === "true") {
      this.display = false;
      return;
    }

    if (!this.active && this.thresholdMet) {
      this.display = true;
      return;
    }

    this.display = false;
  }

  checkRequirement() {
    this.cart.items.forEach(item => {
      if (item.properties && item.properties["_upsell"]) {
        this.active = true;
      }
    });
    if (this.cart.total_price >= this.threshold) {
      this.thresholdMet = true;
    }
  }
}
class AjaxAddToCart extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector("form");
    this.properties = this.querySelectorAll('[name^="properties"]');
    this.submitBtn = this.querySelector('[type="submit"]');

    this.init();
  }

  init() {
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
  }

  onSubmitHandler(e) {
    e.preventDefault();

    const variantId = this.querySelector('[name="id"]').value;
    const errorMessage = this.querySelector(".product-form__error-message-wrapper");
    const errorMessageText = this.querySelector(".product-form__error-message");
    const properties = Array.from(this.properties).map(obj => ({
      name: obj.name.split("[")[1].split("]")[0],
      value: obj.value,
    }));
    errorMessage && errorMessage.setAttribute("hidden", "hidden");

    this.disableButton();

    const formData = {
      items: [
        {
          quantity: 1,
          id: parseInt(variantId),
        },
      ],
    };

    if (properties.length > 0) {
      formData.items[0]["properties"] = {};
      properties.forEach(prop => {
        formData.items[0]["properties"][prop.name] = prop.value;
      });
    }

    cartAdd(formData, response => {
      if (response.status) {
        if (errorMessage) {
          errorMessage.removeAttribute("hidden");
          errorMessageText.innerHTML = response.description;
        }

        this.disableButton(false);
        return;
      }

      new SlideOutCart().openCart(true);
      this.disableButton(false);
    });
  }

  disableButton(disabled = true) {
    if (disabled) {
      this.submitBtn.setAttribute("aria-disabled", true);
      this.submitBtn.classList.add("loading");
      this.querySelector(".loading-overlay__spinner").classList.remove("hidden");

      return;
    }

    this.submitBtn.classList.remove("loading");
    this.submitBtn.removeAttribute("aria-disabled");
    this.querySelector(".loading-overlay__spinner").classList.add("hidden");
  }
}

customElements.define("add-to-cart-form", AjaxAddToCart);

class CardQuickAdd extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector("form");
    this.openBtn = this.querySelector(".quick-add-button");
    this.waiting;

    this.init();
  }

  init() {
    this.hideQuickAdd();

    window.addEventListener(
      "resize",
      e => {
        clearTimeout(this.waiting);
        this.waiting = setTimeout(() => this.hideQuickAdd(), 1000);
      },
      true,
    );

    this.openBtn.addEventListener("click", e => this.onOpenHandler(e));
    this.addEventListener("mouseleave", e => this.onOpenHandler(e, true));
  }

  hideQuickAdd() {
    const formHeight = this.querySelector(".quick-add-form").offsetHeight;
    const containerContentHeight = this.closest(".card").offsetHeight - 30;

    if (formHeight > containerContentHeight) {
      this.openBtn.classList.add("hidden");
    } else {
      this.openBtn.classList.remove("hidden");
    }
  }

  onOpenHandler(e, close) {
    e.preventDefault();

    const isHidden = this.form.classList.contains("hide");
    const formHeight = this.querySelector(".quick-add-form").offsetHeight;
    const btnHeight = this.openBtn.offsetHeight;

    this.style.minHeight = `${btnHeight}px`;

    if (close && isHidden) return;

    if (close) {
      setTimeout(() => {
        this.openBtn.classList.remove("hidden");
        this.form.classList.add("hide");
        this.form.style.height = "";
      }, 300);

      return;
    }

    this.openBtn.classList.add("hidden");
    this.form.classList.remove("hide");
    this.form.style.height = `${formHeight}px`;

    setTimeout(() => {
      this.form.style.height = `auto`;
    }, 300);
  }

}

customElements.define("card-quick-add", CardQuickAdd);

class SmoothScroll extends HTMLElement {
  constructor() {
    super();

    this.init();
  }

  init() {
    this.addEventListener("click", e => this.scrollToProductForm(e));
  }

  scrollToProductForm(e) {
    e.preventDefault();

    const href = this.getAttribute("href");
    const offsetTop = document.querySelector(href)?.offsetTop;
    const fixedHeaderHeight = document.querySelector(".header")?.offsetHeight;

    if (offsetTop == null) return;

    scroll({
      top: offsetTop - fixedHeaderHeight,
      behavior: "smooth",
    });
  }
}

customElements.define("smooth-scroll", SmoothScroll);

//If user is on challenge page, scroll page to top
const scrollPageToTop = () => {
  const pagePath = window.location.href;
  const pathArr = pagePath.split('/');
  const path = pathArr[3].split('#')[0].split('?')[0];
  const isChallengePage = path.indexOf("challenge") > -1;

  if (isChallengePage) {
    setTimeout(() => {
      scroll({
        top: 0,
        behavior: "smooth"
      });
    }, 1000);
  }

};

scrollPageToTop();

// TODO: ShippingProgressBar and GwpProgressBar repeating code.
class ShippingProgressBar extends HTMLElement {

  constructor() {
    super()

    this.data = this.getJSONData('shipping_threshold')
    if (this.data == null) return null;
    const { shipping_threshold: { shipping_threshold_number } } = this.data;
    this.threshold = shipping_threshold_number;
    this.progressBar = this.querySelector('.progress-bar');
    this.heading = this.querySelector('[data-heading]')
    this.observerTotal();
  }

  getJSONData(eleId) {
    const ele = document.getElementById(eleId);
    const data = ele && JSON.parse(ele.textContent);
    return data;
  }

  moveProgress(currentTotal) {
    const percentage = currentTotal / this.threshold * 100
    const progressBarFiller = percentage < 100 ? percentage : 100;

    this.progressBar.style.width = progressBarFiller + "%"
    this.updateHeading(currentTotal);
  }

  updateHeading(currentTotal) {
    const priceToGo = this.threshold - currentTotal;
    if (currentTotal < this.threshold) {
      const message = this.data.shipping_threshold.shipping_threshold_message
      this.heading.innerHTML = message.replace('{{threshold}}',`$${priceToGo.toFixed(2)}`)
    }
    if (currentTotal >= this.threshold) {
      this.heading.innerHTML = this.data.shipping_threshold.shipping_threshold_success
    }
  }

  /**
   * Listens to [data-total] for change then executes moveProgress()
   * @returns void
   */
  observerTotal() {
    const currentTotal = document.querySelector('[data-total]')
    if (currentTotal == null) return null;

    const mutationCallback = (mutations) => {
      if (mutations[0] == null) return null;

      const { target: { dataset: { price } } } = mutations[0]
      this.moveProgress(parseFloat(price), price)
    }

    const mu = new MutationObserver(mutationCallback)
    mu.observe(currentTotal, { childList: true })

  }
}

customElements.define('shipping-progress-bar', ShippingProgressBar)

// TODO: ShippingProgressBar and GwpProgressBar repeating code.
class GwpProgressBar extends HTMLElement {

  constructor() {
    super()

    this.data = this.getJSONData("gwp-data");
    if (this.data == null) return null;
    const { gwp: { gwp_threshold } } = this.data;
    this.threshold = gwp_threshold;
    this.progressBar = this.querySelector('.progress-bar');
    this.heading = this.querySelector('[data-heading]')
    this.observerTotal();
  }

  getJSONData(eleId) {
    const ele = document.getElementById(eleId);
    const data = ele && JSON.parse(ele.textContent);
    return data;
  }

  moveProgress(currentTotal) {
    const percentage = currentTotal / this.threshold * 100
    const progressBarFiller = percentage < 100 ? percentage : 100;

    this.progressBar.style.width = progressBarFiller + "%"
    this.updateHeading(currentTotal);
  }

  updateHeading(currentTotal) {
    const priceToGo = this.threshold - currentTotal;
    if (currentTotal < this.threshold) {
      this.heading.innerHTML = `You are $${priceToGo.toFixed(2)} away from free gift.`
    }
    if (currentTotal >= this.threshold) {
      this.heading.innerHTML = `You are eligible for a free gift.`
    }
  }

  /**
   * Listens to [data-total] for change then executes moveProgress()
   * @returns void
   */
  observerTotal() {
    const currentTotal = document.querySelector('[data-total]')
    if (currentTotal == null) return null;

    const mutationCallback = (mutations) => {
      if (mutations[0] == null) return null;

      const { target: { dataset: { price } } } = mutations[0]
      this.moveProgress(parseFloat(price))
    }

    const mu = new MutationObserver(mutationCallback)
    mu.observe(currentTotal, { childList: true })

  }
}

customElements.define('gwp-progress-bar', GwpProgressBar)